<mat-form-field class="example-full-width">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [formControl]="activeControl"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [disabled]="disabled"
  />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ displayWith(option) }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="errorMessage">
    {{ errorMessage }}
  </mat-error>
</mat-form-field>
